import experted from './expert'
import simpled from './simple'
import recorded from './record'

export const expert = experted
export const simple = simpled
export const record = recorded



// WEBPACK FOOTER //
// ./src/constants/tooltips/index.js